import { ObjectSchema, object } from "yup";
import FormikStep from "../form/FormikStep";
import FormikStepper, { IConfirmation, IStepsList } from "../form/FormikStepper";
import { FormikHelpers, FormikValues } from "formik";
import { Col, Container } from "react-bootstrap";
import { SimpleFormSelectOption } from "../form/SimpleFormSelect";

export interface IPlanningForm {
    initialValues?: object;
    moneySiteOptions?: SimpleFormSelectOption[];
    stepsList?: IStepsList[];
    maxSteps?: number;
    validationSchema?: ObjectSchema<any>;
    currentStep?: number;
    goToStep?(step: number): void;
    onSubmit?(values: FormikValues, formikHelpers: FormikHelpers<FormikValues>): void;
    confirmation?: IConfirmation;
}

const PlanningForm = (props: IPlanningForm) => {
    const {
        initialValues = {},
        validationSchema = object({}),
        currentStep = 0,
        maxSteps = 0,
        stepsList,
        goToStep = () => {},
        onSubmit = () => {},
        confirmation,
    } = props;

    return (
        <Container>
            <div
                className="stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid first"
                data-kt-stepper="true"
            >
                <Col className="stepper-nav" sm={4}>
                    {stepsList?.map((step, index) => (
                        <div
                            key={index}
                            className={`stepper-item ${currentStep == index ? "current" : ""}`}
                        >
                            <div className="stepper-wrapper">
                                <div className="stepper-icon w-40px h-40px">
                                    <i className="stepper-check fas fa-check"></i>
                                    <span className="stepper-number">{index + 1}</span>
                                </div>
                                <div className="stepper-label">
                                    <h3 className="stepper-title">{step.title}</h3>
                                </div>
                            </div>
                            {maxSteps != index + 1 && <div className="stepper-line h-40px" />}
                        </div>
                    ))}
                </Col>
                <Col>
                    <FormikStepper
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        currentStep={currentStep}
                        goToStep={goToStep}
                        onSubmit={onSubmit}
                        confirmation={confirmation}
                    >
                        {stepsList?.map((step, index) => (
                            <FormikStep key={index} validationSchema={step.validationSchema}>
                                {step.element}
                            </FormikStep>
                        ))}
                    </FormikStepper>
                </Col>
            </div>
        </Container>
    );
};

export default PlanningForm;
